// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { MaterialOut } from './materialOut.zod.ts';

export const MaterialSaveOut = zod.object({
  "material": MaterialOut,
  "revision": zod.int()
});

export type MaterialSaveOut = zod.input<typeof MaterialSaveOut>;
export type MaterialSaveOutOutput = zod.output<typeof MaterialSaveOut>;
